import React , {useState, useEffect} from 'react';
import LandHeader from './LandHeader';
import './Landing.css';
import { useNavigate, useLocation } from "react-router-dom";
import logo from '../../assets/Images/logo rev.png';
 import banner from '../../assets/Images/Girl.png';
import landing1 from '../../assets/Images/Group 312.png';
import { IoMdCheckboxOutline } from "react-icons/io";
import landing2 from '../../assets/Images/Group 310.png';
import bannerVector from '../../assets/Images/bg free trial.png'
import maskphoto from '../../assets/Images/Mask group (1).png';
import maskphoto2 from '../../assets/Images/Mask group.png'
import prof from '../../assets/Images/Group 319.png'
import landing5 from '../../assets/Images/Group 289.png';
import landing6 from '../../assets/Images/Group 407.png';
import curve from '../../assets/Images/Rectangle 3772.png';
import axios from 'axios';
import Swal from 'sweetalert2';
// import { IoMdChatbubbles } from "react-icons/io";
import { BiRightArrowAlt } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { RiArrowDropDownLine } from "react-icons/ri";
import {  Switch } from '@mui/material';
import { styled } from '@mui/material/styles';


function LandingPage() {

  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;


  const navigate = useNavigate();
 const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [chat, setChat] = useState([]);
  
  const [email, setEmail] = useState('');
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
     const [showpopup, setShowPopup] = useState(false);
     const [isExpanded, setIsExpanded] = useState(false);
      const [isOpen, setIsOpen] = useState(false);
       const [isOpen2, setIsOpen2] = useState(false);
       const [showBanner, setShowBanner] = useState(false);
       const [nonNecessaryEnabled, setNonNecessaryEnabled] = useState(true); // default true

    const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true); // show banner for first-time users
    } else {
      const parsedConsent = JSON.parse(consent);
      setNonNecessaryEnabled(parsedConsent.nonNecessaryEnabled);
      if (!parsedConsent.nonNecessaryEnabled) {
        setShowBanner(true); // show banner if user disabled cookies
      } else {
        setShowBanner(false);
      }
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ nonNecessaryEnabled: true })
    );
    setNonNecessaryEnabled(true);
    setShowBanner(false);
  };
  
  const handleSaveExit = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ nonNecessaryEnabled })
    );
  
    if (nonNecessaryEnabled) {
      setShowBanner(false); // hide if enabled
    } else {
      setShowBanner(true); // show if disabled
    }
    setShowPopup(false);
  };
   const content = `This website uses cookies to improve your experience while
   you navigate through the website. Out of these cookies, the cookies that are categorized as necessary 
   are stored on your browser as they are as essential for the working of basic functionalities of the 
   website. We also use third-party cookies that help us analyze and understand how you use this website.
    These cookies will be stored in your browser only with your consent. You also have the option to
     opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing
      experience.`;

      const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  const toggleContent = () => {
    setIsOpen2(false);
    setIsOpen(!isOpen);
    
  }

  const toggleContent2 = () => {
    setIsOpen(false)
    setIsOpen2(!isOpen2)
    
  }

  const handleClose = () => {
    setShowPopup(false);
  }

  const CustomSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
      width: 60,
      height: 25,
      padding: 0,
      display: 'flex',
      marginLeft:10,
      '& .MuiSwitch-switchBase': {
        padding: 4,
        '&.Mui-checked': {
          transform: 'translateX(26px)',
          color: '#009F0B',
          '& + .MuiSwitch-track': {
            backgroundColor: '#009F0B',
            '&:before': {
              left: 8,
            },
          },
        },
      },
      '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
        width: 19,
        height: 19,
        borderRadius: '50%',
        backgroundColor: '#D9D9D9',
        marginLeft:5,
      },
      '& .MuiSwitch-track': {
        position: 'relative',
        borderRadius: 34 / 2,
        backgroundColor: 'grey',
        transition: theme.transitions.create(['background-color'], {
          duration: 500,
        }),
        '&:before': {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: 34,
          color: 'white',
          fontSize: 12,
          fontWeight: 600,
        },
      },
    })
  );

  const cookiePopup = () => {
    setShowPopup(true);
  }

   const handlePricingClick = async () => {
    if (!email) {
      alert("Please enter a valid email address");
      return;
    }

    try {
      await axios.post(`${baseURL}/api/send-mail`, { email });
      Swal.fire({
      icon: "success",
      title: "Success",
      text: "Email sent successfully!",
    });
    } catch (error) {
      console.error("Error sending email:", error);
      Swal.fire({
      icon: "error",
      title: "Oops!",
      text: "Failed to send email. Please try again later.",
    });
    }
  };


//  const toggleChat = () => setOpen(!open);

//  const sendMessage = async () => {
//     const userMsg = { sender: 'user', text: message };
//     setChat(prev => [...prev, userMsg]);

//     const response = await axios.post(`${baseURL}/message`, {
//       message: message,
//     });

//     const botMsg = { sender: 'bot', text: response.data.reply };
//     setChat(prev => [...prev, botMsg]);
//     setMessage('');
//   };

  
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//code.tidio.co/jvv1c4iihhivgeguhxf9htan43mttvv5.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const openChat = () => {
    if (window.tidioChatApi) {
      window.tidioChatApi.open();
    } else {
      console.warn("Tidio API not ready yet.");
    }
  };


 

  return (
    <>
     <div>
       <img src={bannerVector} alt="vector background" className='banner-vector' />
    </div>
    <div>
 <div className="header">
  <div className="container">
    <div className="header-logo">
      <img
        src={logo}
        alt="octonius-logo"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      />
    </div>

    {/* Hamburger button */}
    <button className="hamburger" onClick={toggleMenu}>☰</button>

    {/* Nav Menu */}
    <div className={`nav-menu ${menuOpen ? "open" : ""}`}>
      {/* Close button inside nav */}
      <button className="close-btn" onClick={toggleMenu}><IoMdClose /></button>

      <nav className={`menu ${location.pathname === "/" ? "active" : ""}`} onClick={() => navigate("/")}>
        Home
      </nav>
      <nav className={`menu ${location.pathname === "/features" ? "active" : ""}`} onClick={() => navigate("/features")}>
        Features
      </nav>
      <nav className={`menu ${location.pathname === "/pricing" ? "active" : ""}`} onClick={() => navigate("/pricing")}>
        Pricing
      </nav>
      <nav className={`menu ${location.pathname === "/contact" ? "active" : ""}`} onClick={() => navigate("/contact")}>
        Contact
      </nav>

      <div className="free-login">
        <nav className="menu" onClick={() => window.open("https://app.revenuintel.com", "_blank")}>
  Login
</nav>
        <button className="log-btn" onClick={() => navigate('/free-trial')}>
          Free Trial <span className="btn-icon"><BiRightArrowAlt /></span>
        </button>
      </div>
    </div>
  </div>
</div>



   </div>
   <div className='landing-page'>
   
   <div className='banner-content'>
        <div className='land-title'>
            <div className='land-title1'>AI Agents +</div>
            <div className='land-title2'> Human Verified B2B Data </div>
            <div className='land-title4'> Trusted Accuracy with 98% Guaranteed Deliverability </div>
                   <div className='btns'>
               <button className='see-prc' onClick={openChat}>Talk to Us <span className="btn-icon"><BiRightArrowAlt /> </span></button>
                 <button className='demo-btn' onClick={() => {navigate("/free-trial"); window.scrollTo(0, 0); }}>Free Trial 
                   <span className="btn-icon"><BiRightArrowAlt /> </span></button>
                </div>
        </div>
        <div className='land-banner-img'>
          <img src={banner} alt="banner" width="470px" height="400px"  />
        </div>
         {/* {showBot && ( 
          <df-messenger
  intent="WELCOME"
  chat-title="MyWebsiteBot"
  agent-id="jvv1c4iihhivgeguhxf9htan43mttvv5"
  language-code="en"
></df-messenger>
         )} */}

          {/* {showChat && (
        <div className="chat-popup">
          <div className="chat-header">Chat with us</div>
          <div className="chat-body">
            {messages.map((msg, i) => (
              <div key={i} className={`msg ${msg.sender}`}>
                {msg.text}
              </div>
            ))}
          </div>
          <div className="chat-footer">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Type a message..."
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      )} */}
      <div className="chat-widget-container">
      {/* {!open && (
        <div className="chat-card" onClick={() => setOpen(true)}>
          <p className="chat-title"><IoMdChatbubbles /></p>
        </div>
      )}

      {open && (
        <div className="chat-popup">
          <div className="chat-header">
            <span>Chat with us</span>
            <button className="close-btn" onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="chat-body">
            {chat.map((msg, index) => (
              <div key={index} className={msg.sender}>{msg.text}</div>
            ))}
          </div>
          <div className="chat-footer">
            <input
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )} */}
    </div>
       {/* <div className='banner-wrapper'>
     <img src={banner} alt="main banner" className='banner' /> 
  </div> */}
        
        </div>
        <div className='landing-1'>
              <div className='landing-paras'>
                  <div className='land-cont1-1' style={{marginLeft:"7px"}}>
          Human Verified Contacts
              </div>
              <div className='land-cont2'>
        Go from scrambling to grabbing all the opportunities revenuintel uses Human-Verified contacts with Actionable B2B Intelligence, 
              powered by real experts, not just raw data. Our profiles are generated on 
              demand, are rich, continuously updated by our team of human researchers,
            and include firmographics, technographics, and job roles, so you always
            engage with clean, trustworthy data.
              </div>
              <div className='land-cont3'>
              <div className='land-icon'>
                <IoMdCheckboxOutline className='check-icon' />
                <div className='check-content'>Get the most up-to-date data</div>
              </div>
              <div className='land-icon'>
                <IoMdCheckboxOutline className='check-icon' />
                <div className='check-content'>Know what information they need <br /> right now</div>
              </div>
              </div>
              <div className='land-cont3'>
              <div className='land-icon'>
                <IoMdCheckboxOutline className='check-icon' />
                <div className='check-content' style={{marginRight:"26px"}}>We leverage diverse data to provide <br />impactful,actionable insights for your ICP.</div>
              </div>
              <div></div>
              </div>
                
              <div className='land-cont4'>
             
                <span style={{fontSize:"20px", fontWeight:"bold"}}>“</span>Before, we used seven different sources to research and learn about our clients'
               businesses. Now with revenuintel solution, we do it two times faster.<span style={{fontSize:"20px", fontWeight:"bold"}}>”</span> 
                
              </div>
              <div className='cosmin' style={{display:"flex", flexDirection:"row"}}>
                <div className='check-content-img'>
                  <img src={maskphoto} alt="maskphoto" width="50px" />
                </div>
              <div>
              <div className='check-content' style={{marginTop:"30px", fontWeight:"bold"}}>
              – Cosmin Ciobanu, 
              </div>
               <div className='check-content2' style={{ marginLeft: "20px", fontWeight:"400"}}>
               Founder and CEO of Octonius 
              </div>
              </div>
              </div>
           
              </div>
              <div>
              <img className='landing-img1' src={landing1} alt="landing" width="550px" height="400px" />
              </div>
        </div>
        <div className='landing-2'>
           <div>
              <img className='landing-img2' src={landing2} alt="landing" width="547px" height="447px" />
              </div>
          <div className='landing-paras2'>
              <div className='land-cont1-1'>
              {/* Get actionable buyer insights in <br />less than an hour */}
              Tech & AI-Driven GTM Recommendations
              </div>
              <div className='content-2' >
              We combine cutting-edge technology & AI,with human insight to help you reach
              the right people, at the right time, with the right message.From defining your ideal
             Customer Profile (ICP) to optimizing outreach, our tech and AI don’t just show you
             data, they help you act on it with purpose.
              </div>
              <div className='land-cont3'>
              <div className='land-icon'>
                <IoMdCheckboxOutline className='check-icon2' style={{marginLeft:"35px"}} />
                <div className='check-content'>Use filters to dice down your data to <br /> relevant prospects</div>
              </div>
              <div className='land-icon-7'>
                <IoMdCheckboxOutline className='check-icon' />
                <div className='check-content'>360º analysis of prospects</div>
              </div>
              </div>
              <div className='land-cont3'>
              <div className='land-icon'>
                <IoMdCheckboxOutline className='check-icon2' style={{marginLeft:"35px"}} />
                <div className='check-content'>Get more strategic and more <br />thoughtful; no more spray and pray</div>
              </div>
              </div>
              
              <div className='content-3'>
              <span style={{fontSize:"20px", fontWeight:"bold"}}>“</span> Makes outbound feel less cold and makes it warmer.
               A must for anyone doing even outbound.
              Brilliant research tool. It helped me build better relationships with my key contacts.<span style={{fontSize:"20px", fontWeight:"bold"}}>”</span> 
            
              </div>
               <div className='cosmin' style={{display:"flex", flexDirection:"row"}}>
                <div className='check-content-img' style={{marginLeft:"60px"}}>
                  <img src={prof} alt="maskphoto" width="50px" />
                </div>
              <div>
              <div className='check-content' style={{marginTop:"30px", fontWeight:"bold"}}>
              Bruhanudeen
              </div>
               <div className='check-content2' style={{marginLeft:"10px", fontWeight:"400"}}>
              CTO, Alphabit Technologies
              </div>
              </div>
              </div>
             
              </div>
             
              </div>
              <div className='landing-2'>
          
          <div className='landing-paras2'>
              <div className='land-cont1-1'  >
              {/* Get actionable buyer insights in <br />less than an hour */}
             Expert Lead Generation Consulting
              </div>
              <div className='content-2'
              //  style={{marginLeft:"50px", width:"500px", textAlign:"left", marginTop:"25px"}}
               >
            Every subscription includes hands-on support from proven experts to help
             you and your team turn our insights into qualified pipeline; no extra cost, no
             fluff, Just Results !
              </div>
              <div className='land-cont3'>
              <div className='land-icon'>
                <IoMdCheckboxOutline className='check-icon2' />
                <div className='check-content'>Run targeted Campaigns</div>
              </div>
              <div className='land-icon-6'>
                <IoMdCheckboxOutline className='check-icon' />
                <div className='check-content'>GTM Success, Guaranteed</div>
              </div>
              </div>
                
              <div className='content-3' style={{marginTop:"20px"}}>
            <span style={{fontSize:"20px", fontWeight:"bold"}}>“</span> Quality data is fully verified along with all the insights
              facilitated to achieve our business goals.<span style={{fontSize:"20px", fontWeight:"bold"}}>”</span> 
           
              </div>
               <div className='cosmin' style={{display:"flex", flexDirection:"row"}}>
                <div className='check-content-img'>
                  <img src={prof} alt="maskphoto" width="50px" style={{marginLeft:"40px"}} />
                </div>
              <div>
              <div className='check-content' style={{marginTop:"30px", fontWeight:"bold"}}>
            Eddie Moojen,
              </div>
               <div className='check-content2' style={{ fontWeight:"400"}}>
              Chief Technology Officer and Founder of Opentracker
              </div>
              </div>
              </div>
             
              </div>
              <div>
              <img className='landing-img2' src={landing5} alt="landing" width="540px" height="369px"  />
              </div>
              </div>
               <div className='content-1' style={{
    fontStyle: 'italic',
    fontWeight: 500, 
  }} >
             Revenuintel = More Meetings, Guaranteed !!!
              </div>
              <div className='landing-2'> 
           <div>
              <img className='landing-img2' src={landing6} alt="landing" width="530px" height="387px"  />
              </div>
          <div className='landing-paras2'>
              
              <div className='land-cont1-1' >
            Get revenuintel today
              </div>
                
              <div className='content-3'>
            <span style={{fontSize:"20px", fontWeight:"bold"}}>“</span> 
           Revenuintel is the ONLY Demand Generation Intelligence platform that helps sales teams consistently book more qualified meetings. By combining human-verified prospect data with AI-driven engagement agents, Revenuintel transforms your pipeline from guesswork into a predictable, revenue-generating engine.
<span style={{fontSize:"20px", fontWeight:"bold"}}>”</span> 
              
              </div>
             
              </div>
              </div>
              <div className="launch">
  <span className="launch-text">Launch Your Pipeline Now</span>
  <button className='see-prc-launch' onClick={() => {navigate("/free-trial"); window.scrollTo(0, 0); }} >Free Trial <span className="btn-icon"><BiRightArrowAlt /> </span></button>
</div>

              <div className='landing-3'>
               <div className='content-4'>
                Everything We Analyse For You
               </div>
               <div className='land-cont5'>
               Unlocking buyer insights is the cornerstone of account-based marketing. We get into your prospects' heads to figure out
                 how they think, negotiate, and buy! We will do all the hard work for you.
              
              </div>
              <div className='table-cont'>
                <table className='table'>
                  <thead className='tab-head'>
                    <th className='table-th'>Pain Points</th>
                    <th className='table-th'>Executive Talking Points</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td className='tab-data'>Key Decision Makers</td>
                      <td className='tab-data'>Recent Wins</td>
                    </tr>
                    <tr>
                      <td className='tab-data'>Partnerships</td>
                      <td className='tab-data'>Unlock hidden buyer groups and key decision-makers</td>
                    </tr>
                    <tr>
                      <td className='tab-data'>Firmographic Data</td>
                      <td className='tab-data'>Buying patterns</td>
                    </tr>
                    <tr>
                      <td className='tab-data'>Technology Profile</td>
                      <td className='tab-data'>Strategic Initiatives & Budgets</td>
                    </tr>
                    <tr>
                      <td className='tab-data'>Executives</td>
                      <td className='tab-data'>PR Data</td>
                    </tr>
                    <tr>
                      <td className='tab-data'>SEC Fillings</td>
                      <td className='tab-data'>And more.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
              <div className='lead-generating'>
               <span className="lead-text">Start generating B2B leads today!</span>
                <button className='demo-btn-talk' onClick={() => {navigate("/pricing"); window.scrollTo(0, 0); }}>Pricing  <span className="btn-icon"><BiRightArrowAlt /> </span></button>
              </div>
             
              <div className='landing-6'>
              
              <div className='content-9'>
              <span style={{fontSize:"20px", fontWeight:"bold"}}>“</span>Good Insights for IT startups that serves the best for our Inside Sales team.
              I 'would love to recommend to my clients <span style={{fontSize:"20px", fontWeight:"bold"}}>”</span> 
              </div> 
             
               <div className='eran' style={{display:"flex", flexDirection:"column", alignItems:"center",
   marginTop:"10px", color:"black", fontWeight:"700", textAlign:"center", fontSize:"12px"}} >
                <img src={maskphoto2} alt="maskphoto"  width="50px"/> 
                <br />Erhan Eren <div style={{fontWeight:"500"}}>Founder and CEO, Enkiai.com</div></div>  
             

              </div>
          <div className="curved-footer-wrapper">
  <div className="footer-image-container">
    <img src={curve} alt="curve" className="footer-curve-img" />
    <div className="landing-7">
      <div className="land-contents-10">
        We’d love to hear from you <br />
        <span className="land-content-11" style={{marginTop:"20px"}}>support@revenuintel.com</span><br />
       
      </div>
      <div className="land-contents-11">
        Get Revenuintel Today <br />
        <div className="foot-price">
  <input type="email" placeholder='Business mail' className='mail-input' value={email}
        onChange={(e) => setEmail(e.target.value)}/>
  <button className="mail-price-btn"onClick={handlePricingClick}>Pricing</button>
</div>

        
      </div>
      <div className="land-contents-13" style={{fontWeight:"500"}}>
        Powered by, <br />
        Merkat Intellekt Technologies Private Limited
      </div>
    </div>
  </div>
</div>
           
        </div>
         {showBanner && (
                                <div className='cookies'>
                                   <div className='cookie-text'>This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish</div>
                                <div className='cookie' style={{cursor:"pointer"}} onClick={cookiePopup}>Cookie Settings</div>
                                <div> <button className="cookie-btn" onClick={handleAccept}>Accept</button></div>
                                </div> )}
                          {showpopup && (
           <div className="overlay">
             <div className="privacy-popup">
               <div className="privacy-overview">
                 <div className="popup-header">Privacy Overview</div>
                 <div className='privacy-close' onClick={handleClose}><IoIosClose /></div>
               </div>
              <div className="privacy-content">
               {isExpanded ? content : `${content.substring(0, 200)}...`}
               <span
                 className="privacy-content-span"
                 onClick={toggleReadMore}
                 style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
               >
                 {isExpanded ? " See Less" : " See More"}
               </span>
             </div>
            <div className="privacy-neccessary">
               <div className="neccessary-head" >
                 <div className="neccessary-text" onClick={toggleContent}>
                   <RiArrowDropDownLine
                     style={{
                       fontSize: "35px",
                       transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                       transition: "transform 0.3s ease"
                     }}
                   />{" "}
                   Necessary
                 </div>
                 <div className="neccessary-text">Always Enabled</div>
               </div>
         
               {isOpen && (
                 <div className="neccessary-content">
                   Necessary cookies are absolutely essential for the website to
                   function properly. This category only includes cookies that ensure
                   basic functionalities and security features of the website. These
                   cookies do not store any personal information.
                 </div>
               )}
             </div>
              <div className="privacy-neccessary">
               <div className="neccessary-head" >
                 <div className="neccessary-text" onClick={toggleContent2}>
                   <RiArrowDropDownLine
                     style={{
                       fontSize: "35px",
                       transform: isOpen2 ? "rotate(180deg)" : "rotate(0deg)",
                       transition: "transform 0.3s ease"
                     }}
                   />{" "}
                  Non-Necessary
                 </div>
                 <div> <CustomSwitch checked={nonNecessaryEnabled}
                       onChange={(e) => setNonNecessaryEnabled(e.target.checked)} /></div>
               </div>
         
               {isOpen2 && (
                 <div className="neccessary-content">
                  Any cookies that may not be particularly necessary for the website to function
                   and is used specifically to collect user personal data via analytics, ads, other embedded 
                   contents are termed as non-necessary cookies. It is mandatory to procure user consent prior
                    to running these cookies on your website.
                 </div>
               )}
             </div>
             <div className='privacy-save'>
               <button className='privacy-save-btn' onClick={handleSaveExit}>Save & Exit</button>
             </div>
             </div>
           </div>
         )}
  </>
  )
}

export default LandingPage;